// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExpenseConciliationDespesasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for expense_conciliation_despesas /payroll/expense_conciliation_despesas
 * Returns array of linked despesas with categoria
 */
import type { Payroll_DespesaRow } from './Payroll_DespesaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ExpenseConciliationDespesasResponseDados = Payroll_DespesaRow[];

export type Payroll_ExpenseConciliationDespesasResponse = ApiResponse<Payroll_ExpenseConciliationDespesasResponseDados>;

registerResponseContract('Payroll_ExpenseConciliationDespesasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      despesa_id:                        { type: 'number',  required: true },
      despesa_titulo:                    { type: 'string',  required: true },
      despesa_descricao:                 { type: 'string',  required: false },
      despesa_franquia_id:               { type: 'number',  required: true },
      despesa_usuario_id:                { type: 'number',  required: true },
      despesa_usuario_alvo_id:           { type: 'number',  required: false },
      despesa_categoria_id:              { type: 'number',  required: true },
      despesa_data_lancamento:           { type: 'string',  required: true },
      despesa_data_vencimento:           { type: 'string',  required: false },
      despesa_tipo_mensal:               { type: 'number',  required: true },
      despesa_status:                    { type: 'number',  required: true },
      despesa_parcela:                   { type: 'number',  required: true },
      despesa_qtd_parcelas:              { type: 'number',  required: true },
      despesa_valor:                     { type: 'number',  required: true },
      despesa_payroll_period_id:         { type: 'number',  required: false },
      despesa_generated_from_payroll:    { type: 'number',  required: true },
      despesa_generated_from_payroll_id: { type: 'number',  required: false },
      plano_conta_id:                    { type: 'number',  required: false },
      categoria:                         { type: 'string',  required: false },
    },
  },
})
